/* Arjit4Amply: two independent, decoupled behaviors for the reskinned cart
   drawer (snippets/cart-drawer.liquid) - neither touches Dawn's own
   cart-drawer.js/cart.js, both just observe/reuse what's already there.

   1. "Just added" announcement banner ("Calm is in your bag..."). Dawn's
      real add-to-cart flow (product-form.js) publishes a cartUpdate pub/sub
      event with the added item's real product_title BEFORE swapping the
      drawer's markup in via renderContents() - by the time that swap
      happens the announcement element is a fresh, empty one from the
      server-rendered section, so the title has to be re-applied after the
      swap, not before. A MutationObserver (rather than guessing at a fixed
      delay) reapplies it the moment the drawer's DOM actually changes.

      Confirmed against the reference that this banner PERSISTS across
      later quantity changes/plan switches within the same cart, not just
      the one render right after adding - every one of those also replaces
      the whole section (wiping out an in-memory-only value), so the last
      announced title is kept in sessionStorage and re-applied on every
      subsequent render too, cleared only once the cart is actually empty.

   2. The per-line "Purchase option" select. Shopify's cart has no endpoint
      to change an existing line's selling plan in place, so switching plans
      here removes the old line and adds a fresh one under the new plan (or
      with no plan at all for "One-time purchase" - the same real one-time
      path the PDP's own "Buy one time" link already uses), then reuses
      cart-drawer-items' own real onCartUpdate() to re-render, instead of
      duplicating that logic. */
(function () {
  var STORAGE_KEY = 'matre-cart-announcement-title';

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source !== 'product-form') return;
      var title = event.cartData && (event.cartData.product_title || event.cartData.title);
      if (title) sessionStorage.setItem(STORAGE_KEY, title);
    });
  }

  // Arjit4Amply: real product titles come back from /cart/add.js ALL CAPS
  // ("CALM") - re-cased the same way as the server-rendered line-item
  // titles in cart-drawer.liquid, so the two don't visibly disagree.
  function titleCase(title) {
    return title
      .toLowerCase()
      .split(' ')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  function applyPendingAnnouncement() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && cartDrawerEl.classList.contains('is-empty')) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    var title = sessionStorage.getItem(STORAGE_KEY);
    if (!title) return;

    var el = document.getElementById('CartDrawer-Announcement');
    if (!el || !el.hidden) return;
    el.textContent = titleCase(title) + ' is in your bag. Review your routine below.';
    el.hidden = false;
  }

  var cartDrawerRoot = document.getElementById('CartDrawer');
  if (cartDrawerRoot) {
    applyPendingAnnouncement();
    new MutationObserver(applyPendingAnnouncement).observe(cartDrawerRoot, {
      childList: true,
      subtree: true,
    });
  }

  /* Arjit4Amply: Dawn's onCartUpdate() only swaps cart-drawer-items and
     .cart-drawer__footer - the upsell card sits outside both, so it would
     stay stale (old target, old line keys) after any change made here.
     Re-render it from the same section HTML afterwards. */
  function refreshDrawer() {
    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (!cartDrawerItems || typeof cartDrawerItems.onCartUpdate !== 'function') {
      window.location.href = window.routes.cart_url;
      return;
    }
    Promise.resolve(cartDrawerItems.onCartUpdate())
      .then(function () {
        return fetch(window.routes.cart_url + '?section_id=cart-drawer');
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var fresh = html.querySelector('.matre-cart-upsell');
        var current = document.querySelector('#CartDrawer .matre-cart-upsell');
        if (current && fresh) current.replaceWith(fresh);
        else if (current) current.remove();
        else if (fresh) {
          var ctas = document.querySelector('#CartDrawer .cart__ctas');
          if (ctas) ctas.insertAdjacentElement('afterend', fresh);
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-cart-plan-select]');
    if (!select) return;

    var variantId = select.dataset.variantId;
    var lineKey = select.dataset.lineKey;
    var lineItem = select.closest('.matre-cart-item');
    var qtyInput = lineItem ? lineItem.querySelector('.quantity__input') : null;
    var currentQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var newPlanId = select.value;
    /* Arjit4Amply: keep the number of people when switching plans - the
       3-month plan is 3 units per person, 1-month and one-time are 1
       (data-units on each option; the old plan's is the step the line's
       stepper was rendered with). */
    var oldUnits = qtyInput ? parseInt(qtyInput.getAttribute('step'), 10) || 1 : 1;
    var chosen = select.options[select.selectedIndex];
    var newUnits = chosen ? parseInt(chosen.getAttribute('data-units'), 10) || 1 : 1;
    var people = Math.max(1, Math.round(currentQty / oldUnits));
    var quantity = people * newUnits;

    select.disabled = true;

    fetch(window.routes.cart_change_url, Object.assign({}, fetchConfig(), {
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    }))
      .then(function () {
        var addPayload = { items: [{ id: Number(variantId), quantity: quantity }] };
        if (newPlanId) addPayload.items[0].selling_plan = Number(newPlanId);
        return fetch(window.routes.cart_add_url, Object.assign({}, fetchConfig(), {
          body: JSON.stringify(addPayload),
        }));
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.status) {
          var errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = data.description || data.message || window.cartStrings.error;
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(refreshDrawer);
  });

  /* Arjit4Amply: "Switch & save" upsell (snippets/matre-cart-upsell.liquid)
     - client request: swap the cart in place instead of opening the bundle's
     page. Removes every line the bundle already contains (data-remove-keys),
     then adds the bundle on the matching plan and quantity worked out in
     Liquid, then re-renders the drawer the same way as the plan switcher. */
  document.addEventListener('click', function (event) {
    var offer = event.target.closest('[data-cart-upsell-swap]');
    if (!offer) return;
    event.preventDefault();
    if (offer.getAttribute('aria-busy') === 'true') return;
    offer.setAttribute('aria-busy', 'true');

    var updates = {};
    (offer.dataset.removeKeys || '').split(',').forEach(function (key) {
      if (key) updates[key] = 0;
    });
    var item = { id: Number(offer.dataset.variantId), quantity: Number(offer.dataset.quantity) || 1 };
    if (offer.dataset.sellingPlan) item.selling_plan = Number(offer.dataset.sellingPlan);

    fetch(window.routes.cart_update_url, Object.assign({}, fetchConfig(), {
      body: JSON.stringify({ updates: updates }),
    }))
      .then(function () {
        return fetch(window.routes.cart_add_url, Object.assign({}, fetchConfig(), {
          body: JSON.stringify({ items: [item] }),
        }));
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.status) {
          var errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = data.description || data.message || window.cartStrings.error;
          return;
        }
        if (offer.dataset.title) sessionStorage.setItem(STORAGE_KEY, offer.dataset.title);
        var announcement = document.getElementById('CartDrawer-Announcement');
        if (announcement) announcement.hidden = true;
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(refreshDrawer);
  });
})();
